document.addEventListener("DOMContentLoaded", function () {
  const stickyBtn = document.querySelector(".sticky__add___to_cart__btn");
  if (!stickyBtn) return;

  function checkScroll() {
    const scrollTop = window.scrollY || document.documentElement.scrollTop;
    const docHeight = document.documentElement.scrollHeight - window.innerHeight;
    const scrollPercent = (scrollTop / docHeight) * 100;

    if (scrollPercent >= 18) {
      stickyBtn.classList.add("show");
    } else {
      stickyBtn.classList.remove("show");
    }
  }
  window.addEventListener("scroll", checkScroll);
  checkScroll();
});
